<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright-top"><a id="page_iii">Text copyright © 2018 by Carolyn O’Doherty</a></p><a id="page_iii">
<p class="copyright-t">All rights reserved.</p>
</a><p class="copyright"><a id="page_iii">For information about permission to reproduce selections from this book, contact </a><a href="mailto:permissions@highlights.com">permissions@highlights.com</a>.</p>
<p class="copyright-t">This is a work of fiction. Names, characters, places, and incidents are products of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is entirely coincidental.</p>
<p class="copyright-t">Boyds Mills Press</p>
<p class="copyright">An Imprint of Highlights</p>
<p class="copyright">815 Church Street</p>
<p class="copyright">Honesdale, Pennsylvania 18431</p>
<p class="copyright-t">Printed in the United States of America</p>
<p class="copyright">ISBN: 978-1-62979-814-1 (hc)</p>
<p class="copyright">ISBN: 978-1-68437-138-9 (eBook)</p>
<p class="copyright-t">Library of Congress Control Number: 2017961199</p>
<p class="copyright-t">First e-book edition</p>
<p class="copyright">The text of this book is set in Janson MT.</p>
<p class="copyright">H1.0</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Copyright.vue?f42184ec